import ApiServices from "@/services/api.service";

class DraftService {

  static async upsertDraft(draft) {
    try {
      let token = localStorage.getItem("token");
      let api = process.env.VUE_APP_BASE_URL + `/drafts/upsert_draft`;
      const res = await fetch(api, ApiServices.requestOptions("POST", JSON.stringify({ draft }), token));
      const jsonObject = await res.json();
      if (res.status >= 400) {
        return null;
      }
      return jsonObject;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  // מחזיר את מסמך הטיוטה, או null אם אין. שגיאה גם מחזירה null בכוונה,
  // כדי שכשל בבדיקת טיוטה לא יעצור את תהליך הקמת המנוי הרגיל.
  static async getDraftByCardId(cardId) {
    try {
      let token = localStorage.getItem("token");
      let api = process.env.VUE_APP_BASE_URL + `/drafts/get_draft_by_card_id?card_id=${encodeURIComponent(cardId)}`;
      const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
      const jsonObject = await res.json();
      if (res.status >= 400) {
        return null;
      }
      return jsonObject;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  static async getMyDrafts() {
    try {
      let token = localStorage.getItem("token");
      let api = process.env.VUE_APP_BASE_URL + `/drafts/get_my_drafts`;
      const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
      const jsonObject = await res.json();
      if (res.status >= 400) {
        return [];
      }
      return jsonObject;
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  static async deleteDraft(draftId) {
    try {
      let token = localStorage.getItem("token");
      let api = process.env.VUE_APP_BASE_URL + `/drafts/delete_draft`;
      const res = await fetch(api, ApiServices.requestOptions("POST", JSON.stringify({ draft_id: draftId }), token));
      if (res.status >= 400) {
        return false;
      }
      return true;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
}

export default DraftService;